var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMyWorlds = function SvgIconMyWorlds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    fillRule: "evenodd",
    d: "M21.6 6.6a.61.61 0 0 0-.319-.542l-8.72-4.716c-.35-.19-.77-.19-1.121 0L2.72 6.058a.61.61 0 0 0-.32.542v10.8a.61.61 0 0 0 .32.543l8.72 4.715c.35.19.77.19 1.12 0l8.721-4.716a.6.6 0 0 0 .32-.542zm-17.4.458v9l6.9-3.732v-9zm8.7-3.732v9l6.9 3.731v-9zm-1.46 17.532L5.046 17.4l6.394-3.457c.35-.19.77-.19 1.12 0l6.394 3.457-6.393 3.458c-.35.19-.77.19-1.121 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M12.282 1.35a.6.6 0 0 0-.563 0l-9 4.78a.6.6 0 0 0-.319.53v10.042a.6.6 0 0 0 .882.53l8.437-4.483a.6.6 0 0 1 .563 0l8.437 4.483a.6.6 0 0 0 .881-.53V6.66a.6.6 0 0 0-.318-.53z",
    opacity: 0.4
  })));
};
export default SvgIconMyWorlds;